<template>
    <div v-if="alert.text" :class="alertClasses" role="alert">
        {{alert.text}}
    </div>
</template>

<script>
import moment from "moment";
import lang from '@tv/filters/lang';

export default {
    props: ['payload'],
    computed: {
        alertClasses() {
            return `mt-3 mb-0 alert alert-${this.alert.type}`;
        },
        alert() {
            return {text: this.payload.text ? this.payload.text : lang('error'), 'type': this.payload.success ? 'success' : 'danger'};
        }
    }
}
</script>